import Script from "next/script";
const mapLocale = process.env.NEXT_PUBLIC_MAP_LOCALE;

export const renderBingMapScript = () => {
  const locale = mapLocale;
  if (!locale) return null;
  return (
    <Script
      key={`bing-map-${locale}`}
      type="text/javascript"
      async
      defer
      src={`https://www.bing.com/api/maps/mapcontrol?callback=bingmapsCallback&setLang=${locale}&key=${process.env.NEXT_PUBLIC_MAP_KEY}`}
    />
  );
};
